export enum IdTagColor {
  Black = "black",
  White = "white",
  Silver = "silver",
}
